import { openDB, DBSchema } from "idb";

interface VisitsDB extends DBSchema {
  Visits: {
    key: number;
    value: {
      id?: number
      data: string
      video?: string
    };
  };
}

const dbPromise = openDB<VisitsDB>("Visits", 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains("Visits")) {
      db.createObjectStore("Visits", { keyPath: "id", autoIncrement: false });
    }
  },
});

export async function addVisit(id: number, data: string, video?: string) {
  const db = await dbPromise;
  await db.add("Visits", { id, data, video });
}

export async function hasVisit() {
  const db = await dbPromise;
  const count = await db.count("Visits");
  return count > 0;
}

export async function getAllVisit() {
  const db = await dbPromise;
  return await db.getAll("Visits");
}

export async function getVisitById(id: number) {
  const db = await dbPromise;
  return await db.get("Visits", id);
}

export async function updateVisit(id: number, data: string, video?: string) {
  const db = await dbPromise;
  // var visit = await db.get("Visits", id);
  // if (!visit) throw new Error("Note not found");
  await db.put("Visits", { id, data, video });
}

export async function deleteVisit(id: number) {
  const db = await dbPromise;
  await db.delete("Visits", id);
}